import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './operational-resilience.css'

const OperationalResilience = (props) => {
  return (
    <div className="operational-resilience-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Operational-Resilience - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/operational-resilience"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-resilience">
        <video
          src="https://videos.pexels.com/video-files/6963744/6963744-hd_1280_720_25fps.mp4"
          loop="true"
          muted="true"
          autoPlay="true"
          playsInline="true"
          className="hero-resilience__video"
        ></video>
        <div className="hero-resilience__overlay"></div>
        <div className="hero-resilience__content">
          <div className="hero-resilience__content-inner">
            <div className="hero-resilience__icon-wrapper">
              <svg
                width="64"
                xmlns="http://www.w3.org/2000/svg"
                height="64"
                viewBox="0 0 24 24"
                className="hero-resilience__icon"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h1 className="hero-title hero-resilience__title">
              Operational Resilience
            </h1>
            <p className="hero-resilience__subtitle hero-subtitle">
              Disruption-proof resilience for business continuity and rapid
              recovery in cybersecurity incidents. Build organizational strength
              to withstand, adapt, and recover from any threat scenario.
            </p>
            <div className="hero-resilience__actions">
              <a href="#contact-resilience">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#process-resilience">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>Explore Process</span>
                </div>
              </a>
            </div>
            <div className="hero-resilience__stats">
              <div className="hero-resilience__stat">
                <div className="hero-resilience__stat-value">
                  <span>99.9%</span>
                </div>
                <div className="hero-resilience__stat-label">
                  <span>Uptime Target</span>
                </div>
              </div>
              <div className="hero-resilience__stat">
                <div className="hero-resilience__stat-value">
                  <span>&lt;4hrs</span>
                </div>
                <div className="hero-resilience__stat-label">
                  <span>Recovery Time</span>
                </div>
              </div>
              <div className="hero-resilience__stat">
                <div className="hero-resilience__stat-value">
                  <span>24/7</span>
                </div>
                <div className="hero-resilience__stat-label">
                  <span>Support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features-resilience">
        <div className="features-resilience__container">
          <div className="features-resilience__header">
            <h2 className="features-resilience__title section-title">
              Comprehensive Resilience Services
            </h2>
            <p className="section-subtitle features-resilience__subtitle">
              Tailored disruption recovery planning, business continuity, and
              resilience testing services designed for enterprise-grade security
              and rapid incident response.
            </p>
          </div>
          <div className="features-resilience__grid">
            <div className="features-resilience__card">
              <div className="features-resilience__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="features-resilience__card-title">
                Risk Assessment &amp; Analysis
              </h3>
              <p className="features-resilience__card-description">
                Comprehensive identification and evaluation of potential
                disruption scenarios, vulnerabilities, and critical dependencies
                across your infrastructure and operations.
              </p>
              <ul className="features-resilience__card-list">
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Business Impact Analysis</span>
                </li>
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Dependency Mapping</span>
                </li>
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Threat Scenario Planning</span>
                </li>
              </ul>
            </div>
            <div className="features-resilience__card">
              <div className="features-resilience__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                  </g>
                </svg>
              </div>
              <h3 className="features-resilience__card-title">
                Business Continuity Planning
              </h3>
              <p className="features-resilience__card-description">
                Development of strategic frameworks and actionable playbooks to
                ensure critical operations continue during and after disruption
                events of any magnitude.
              </p>
              <ul className="features-resilience__card-list">
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Recovery Strategy Design</span>
                </li>
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Incident Response Playbooks</span>
                </li>
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Crisis Communication Plans</span>
                </li>
              </ul>
            </div>
            <div className="features-resilience__card">
              <div className="features-resilience__card-icon">
                <svg
                  width="40"
                  xmlns="http://www.w3.org/2000/svg"
                  height="40"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m12 14l4-4M3.34 19a10 10 0 1 1 17.32 0"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="features-resilience__card-title">
                Resilience Testing &amp; Validation
              </h3>
              <p className="features-resilience__card-description">
                Rigorous testing programs including tabletop exercises, live
                simulations, and purple-team assessments to validate and refine
                your resilience capabilities.
              </p>
              <ul className="features-resilience__card-list">
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Tabletop Exercises</span>
                </li>
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Live Simulations</span>
                </li>
                <li className="features-resilience__card-list-item">
                  <svg
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                  <span>Purple Team Assessments</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="cta-resilience">
        <div className="cta-resilience__container">
          <div className="cta-resilience__card">
            <div className="cta-resilience__content">
              <h2 className="cta-resilience__title section-title">
                Ready to Strengthen Your Operational Resilience?
              </h2>
              <p className="section-content cta-resilience__description">
                Schedule a comprehensive resilience assessment with our
                specialists and discover how to build unshakable business
                continuity.
              </p>
            </div>
            <div className="cta-resilience__actions">
              <a href="#contact-resilience">
                <div className="btn-primary btn-xl btn">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#process-resilience">
                <div className="btn-xl btn btn-secondary">
                  <span>View Our Process</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section id="process-resilience" className="process-resilience">
        <div className="process-resilience__container">
          <div className="process-resilience__header">
            <h2 className="process-resilience__title section-title">
              Our Resilience Framework
            </h2>
            <p className="section-subtitle process-resilience__subtitle">
              End-to-end resilience process: risk assessment, continuity
              planning, testing, and continuous improvement for sustained
              operational strength.
            </p>
          </div>
          <div className="process-resilience__steps">
            <div className="process-resilience__step">
              <div className="process-resilience__step-number">
                <span>01</span>
              </div>
              <div className="process-resilience__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="process-resilience__step-title">
                Risk &amp; Impact Assessment
              </h3>
              <p className="process-resilience__step-description">
                Comprehensive analysis of potential disruption scenarios,
                business impact evaluation, and critical asset identification
                across all operational domains.
              </p>
            </div>
            <div className="process-resilience__step-connector"></div>
            <div className="process-resilience__step">
              <div className="process-resilience__step-number">
                <span>02</span>
              </div>
              <div className="process-resilience__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="3" rx="2" width="8" height="8"></rect>
                    <path d="M7 11v4a2 2 0 0 0 2 2h4"></path>
                    <rect x="13" y="13" rx="2" width="8" height="8"></rect>
                  </g>
                </svg>
              </div>
              <h3 className="process-resilience__step-title">
                Continuity Strategy Design
              </h3>
              <p className="process-resilience__step-description">
                Development of tailored recovery strategies, incident response
                playbooks, and continuity frameworks aligned with your
                organizational objectives and risk tolerance.
              </p>
            </div>
            <div className="process-resilience__step-connector"></div>
            <div className="process-resilience__step">
              <div className="process-resilience__step-number">
                <span>03</span>
              </div>
              <div className="process-resilience__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="m9 14l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-resilience__step-title">
                Validation &amp; Testing
              </h3>
              <p className="process-resilience__step-description">
                Rigorous testing through tabletop exercises, live simulations,
                and purple-team assessments to validate preparedness and
                identify areas for enhancement.
              </p>
            </div>
            <div className="process-resilience__step-connector"></div>
            <div className="process-resilience__step">
              <div className="process-resilience__step-number">
                <span>04</span>
              </div>
              <div className="process-resilience__step-icon">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 12a9 9 0 0 1 9-9a9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
                    <path d="M21 3v5h-5m5 4a9 9 0 0 1-9 9a9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
                    <path d="M8 16H3v5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-resilience__step-title">
                Continuous Improvement
              </h3>
              <p className="process-resilience__step-description">
                Ongoing monitoring, periodic reassessment, and iterative
                refinement of resilience capabilities to adapt to evolving
                threats and organizational changes.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="about-resilience">
        <div className="about-resilience__container">
          <div className="about-resilience__header">
            <h2 className="section-title about-resilience__title">
              Compliance Framework Mapping
            </h2>
            <p className="section-subtitle about-resilience__subtitle">
              Map resilience practices to ISO/IEC, SOC, PCI-DSS, and AI GRC
              standards to ensure comprehensive regulatory compliance and
              industry best practices alignment.
            </p>
          </div>
          <div className="about-resilience__table-wrapper">
            <table className="about-resilience__table">
              <thead className="about-resilience__table-head">
                <tr className="about-resilience__table-row">
                  <th className="about-resilience__table-header">
                    <span>Resilience Practice</span>
                  </th>
                  <th className="about-resilience__table-header">
                    <span>ISO/IEC 22301</span>
                  </th>
                  <th className="about-resilience__table-header">
                    <span>SOC 2</span>
                  </th>
                  <th className="about-resilience__table-header">
                    <span>PCI-DSS 4.0</span>
                  </th>
                  <th className="about-resilience__table-header">
                    <span>AI GRC</span>
                  </th>
                </tr>
              </thead>
              <tbody className="about-resilience__table-body">
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Business Impact Analysis</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>8.2.1, 8.2.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>CC9.1</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.10.1</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Risk Assessment</span>
                    </div>
                  </td>
                </tr>
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Recovery Strategy</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>8.3.1, 8.3.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>A1.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.10.3</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Model Resilience</span>
                    </div>
                  </td>
                </tr>
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Incident Response Plans</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>8.4.1, 8.4.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>CC7.3, CC7.4</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.10.4, 12.10.5</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Incident Management</span>
                    </div>
                  </td>
                </tr>
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Testing &amp; Exercises</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>8.5, 9.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>CC9.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.10.7</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Validation Testing</span>
                    </div>
                  </td>
                </tr>
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Communication Protocols</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>8.4.3</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>CC7.5</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.10.6</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Stakeholder Comm</span>
                    </div>
                  </td>
                </tr>
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Continuous Improvement</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>10.1, 10.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>CC3.4</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.10.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Iterative Learning</span>
                    </div>
                  </td>
                </tr>
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Documentation &amp; Records</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>7.5</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>CC3.1</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.5.1</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Audit Trail</span>
                    </div>
                  </td>
                </tr>
                <tr className="about-resilience__table-row">
                  <td className="about-resilience__table-cell--primary about-resilience__table-cell">
                    <span>Third-Party Dependencies</span>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>8.2.4</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>CC9.3</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>12.8.1, 12.8.2</span>
                    </div>
                  </td>
                  <td className="about-resilience__table-cell">
                    <div className="about-resilience__table-badge">
                      <span>Vendor Risk</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section
        id="contact-resilience"
        className="operational-resilience-thq-contact-resilience-elm contact-resilience"
      >
        <div className="contact-resilience__container">
          <div className="operational-resilience-thq-contact-resiliencecard-elm contact-resilience__card">
            <div className="operational-resilience-thq-contact-resiliencecontent-elm contact-resilience__content">
              <h2 className="contact-resilience__title section-title">
                Engage Our Specialists
              </h2>
              <p className="section-content contact-resilience__description">
                Connect with our operational resilience experts to discuss your
                business continuity needs, schedule a comprehensive assessment,
                or learn more about our testing and validation services.
              </p>
            </div>
            <div className="operational-resilience-thq-contact-resilienceform-wrapper-elm contact-resilience__form-wrapper">
              <a href="#contact-expert">
                <div className="operational-resilience-thq-btn-elm5 btn-primary btn-xl btn">
                  <span>Schedule Consultation</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="operational-resilience-thq-testimonials-resilience-elm testimonials-resilience"></section>
      <div className="operational-resilience-container2">
        <div className="operational-resilience-container3">
          <Script
            html={`<style>
        @keyframes heroIconFloat {0%,100% {transform: translateY(0);}
50% {transform: translateY(-10px);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="operational-resilience-container4">
        <div className="operational-resilience-container5">
          <Script
            html={`<script defer data-name="smooth-scroll-handler">
(function(){
  const heroLinks = document.querySelectorAll('a[href^="#"]')

  heroLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href")
      if (targetId === "#") return

      const targetElement = document.querySelector(targetId)
      if (targetElement) {
        e.preventDefault()
        const offsetTop = targetElement.offsetTop
        window.scrollTo({
          top: offsetTop - 80,
          behavior: "smooth",
        })
      }
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default OperationalResilience
